import { render, staticRenderFns } from "./tableadmin.vue?vue&type=template&id=4fb18a9c&"
import script from "./tableadmin.vue?vue&type=script&lang=js&"
export * from "./tableadmin.vue?vue&type=script&lang=js&"
import style0 from "./tableadmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports